// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2j8zc","rootSmall":"AddTileButton_rootSmall__3KsYp"};